import { put, takeLatest } from "redux-saga/effects";
import AxiosCustom from "../../../common/components/apiConfig";
import {
	handleNotificationAlertCatch,
	handleNotificationAlertTrySelect,
} from "../../../common/method/handleNotificationAlert";

export const actionTypes = {
	selectPaymentRequestsHistory: "selectPaymentRequestsHistory [Action]",
	selectPaymentRequestsHistoryLoading:
		"selectPaymentRequestsHistoryLoading [Action]",
	selectPaymentRequestsHistoryAsync:
		"selectPaymentRequestsHistoryAsync [Action]",
};
const inistiaState = {
	data: [],
	loading: false,
	total: 0,
};

export const selectPaymentRequestsHistoryReducer = (
	state = inistiaState,
	{ type, payload },
) => {
	switch (type) {
		case actionTypes.selectPaymentRequestsHistory:
			return {
				...state,
				data: payload?.results,
				total: payload?.total,
			};
		case actionTypes.selectPaymentRequestsHistoryLoading:
			return {
				...state,
				loading: payload,
			};
		default:
			return state;
	}
};

function* handleWorker({ payload }) {
	yield put({
		type: actionTypes.selectPaymentRequestsHistoryLoading,
		payload: true,
	});

	let config = {
		url: "select_request",
	};

	let data = {
		table: "payment",
		method_type: "select_payment_requests_history",
		data: payload?.data ? payload.data : {},
	};

	try {
		let res = yield AxiosCustom(config, data);
		let isOk = handleNotificationAlertTrySelect(res);
		if (!isOk) {
			return;
		}

		yield put({
			type: actionTypes.selectPaymentRequestsHistory,
			payload: res?.data?.response?.data,
		});
	} catch {
		handleNotificationAlertCatch();
	} finally {
		yield put({
			type: actionTypes.selectPaymentRequestsHistoryLoading,
			payload: false,
		});
	}
}

export function* selectPaymentRequestsHistory() {
	yield takeLatest(actionTypes.selectPaymentRequestsHistoryAsync, handleWorker);
}
